
interface Tag {
  disabled: boolean
  label: string
}
import { defineComponent, PropType } from 'vue'
export default defineComponent({
  name: 'HospitalTag',

  props: {
    tags: Array as PropType<Tag[]>,
    lg: {
      type: Boolean,
      default: false
    }
  }
})
